/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {HeaderComponent as ɵa} from './lib/components/header/header.component';
export {ColorDirective as ɵb} from './lib/directives/color.directive';